import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrlback } from '../urlApi'

export const useFirmaContratada = () => {

     
    const [firmaContratada, setFirmaContratada] = useState('checking')

     const getFirmaContratada = async () => {

        const conid = localStorage.getItem('conid')

          try {

            const response = await axios.post(`${baseUrlback}api/helpers/consultarDatosConid`,{conid})
    
            const [ data ] = response.data
            const {empid,sid} = data

            const resp = await axios.post(`${baseUrlback}api/helpers/firmaContratada`, {
                empid,sid
              })

  

          setFirmaContratada(resp.data[0].firmadigital)
           
          } catch (error) {
            console.log(error)
          }





     }


     useEffect(() => {
        getFirmaContratada()
     }, [])
     



  return {firmaContratada}
}
